import { h } from 'preact';
import { useState } from 'preact/hooks';

export const containerStyles = {
    width: '100%',
    height: '100%',
    color: 'white',
    position: 'absolute',
    textAlign: 'center',
    left: '0px',
    top: '0px',
    background: 'rgba(0, 0, 0, 0.92)',
    padding: '16px',
    display: 'flex',
    flexDirection: 'column',
    justifyItems: 'center',
    justifyContent: 'center'
},
buttonStyles = {
    background: 'gray',
    padding: '8px',
    marginTop: '16px',
    textTransform: 'uppercase'
};

export const Confirmer = ({ 
    onSubmit = noop,
    children = [],
    prompt = 'Form Submitted Successfully',
    button = 'Ok',
    style = {} 
}) => {
    const [confirmed, setConfirmed] = useState(false);
    const styles = {
        ...containerStyles,
        ...style
    };
    const onClick = e => {
        setConfirmed(true);
        onSubmit(e);
    };

    return (
        confirmed ? 
            null :
            (
                <div className="confirmer" style={ styles }>
                    <h4>{ prompt }</h4>
                    { children }
                    <button style={ buttonStyles } onClick={ onClick }>{ button }</button>
                </div>
            )
    );
};

function noop(){}